import { render, staticRenderFns } from "./gdigital.vue?vue&type=template&id=6cda174a&scoped=true"
import script from "./gdigital.vue?vue&type=script&lang=js"
export * from "./gdigital.vue?vue&type=script&lang=js"
import style0 from "./gdigital.vue?vue&type=style&index=0&id=6cda174a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda174a",
  null
  
)

export default component.exports